import flatpickr from "flatpickr";
import * as $ from "jquery";
import * as moment from "moment";

$(() => {
    const reason = $("#inputReason").val();
    const checkinDate = $("#checkinDate").val();
    const checkoutDate = $("#checkoutDate").val();
        
    let checkinDateValue: Date | null;
    let checkoutDateValue: Date | null;

    if (reason === "RE") {
        $("#inputDateRange").prop("disabled", false);
        if (checkinDate !== undefined && checkinDate !== "" && checkoutDate !== undefined && checkoutDate !== "") {
            checkinDateValue = moment(checkinDate).toDate();
            checkoutDateValue = moment(checkoutDate).toDate();
        }
    } else {
        $("#inputDateRange").prop("disabled", true);
    }

    //https://flatpickr.js.org/formatting/
    const datePickr: any = flatpickr("#inputDateRange", {
        enableTime: false,
        mode: "range",
        minDate: "today",
        maxDate: new Date("2025-12-31"),
        dateFormat: "l d M Y",
        defaultDate: [checkinDateValue, checkoutDateValue],
        onChange: function (selectedDates, dateStr, instance) {
            if (selectedDates === undefined || selectedDates.length === 0) return;

            if (selectedDates.length > 0) {
                $("#checkinDate").val(moment(selectedDates[0]).format("YYYY-MM-DD"));
            }

            if (selectedDates.length > 1) {
                $("#checkoutDate").val(moment(selectedDates[1]).format("YYYY-MM-DD"));
            }
        }
    });

    $("#inputReason").on("change", (e) => {
        const inDate = $("#inputDateRange");

        const selectedValue = $("#inputReason").val();
        if (selectedValue !== "RE") {
            inDate.prop("disabled", true);
            inDate.val("");
            $("#checkinDate").val("");
            $("#checkoutDate").val("");
            datePickr.clear();
        } else {
            inDate.prop("disabled", false);
        }
    });
});

